import {Component, Inject, Input, OnInit} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {ActivatedRoute, Router} from '@angular/router';
import {CountriesListService} from '../../../services/countries-list.service';

@Component({
    selector: 'user-settings',
    templateUrl: './user-settings.component.html',
    styleUrls: ['./user-settings.component.scss'],
    standalone: false
})
export class UserSettingsComponent implements OnInit {
  profileView: boolean;
  loginActivityView: boolean;
  auditLogView: boolean;
  changePasswordView: boolean;
  changeCommunicationsView: boolean;

  @Input()
  staffView: boolean;

  constructor(private title: Title,
              private countriesListService: CountriesListService,
              private router: Router,
              private activatedRoute: ActivatedRoute,
              @Inject('env') private environment) {
  }

  ngOnInit() {
    this.staffView = this.environment.config.interfaceType === 'STAFF';
    this.getInputData(history.state);
    this.title.setTitle('User Settings');
    this.countriesListService.load();
    this.changeViewToProfile();
    this.setTab();
  }

  getInputData(data: any) {
    if (!data) {
      this.router.navigateByUrl('/user/home');
    }
  }

  changeViewToProfile() {
    this.profileView = true;
    this.auditLogView = false;
    this.loginActivityView = false;
    this.changePasswordView = false;
    this.changeCommunicationsView = false;
  }

  changeViewToLoginActivity() {
    this.profileView = false;
    this.auditLogView = false;
    this.loginActivityView = true;
    this.changePasswordView = false;
    this.changeCommunicationsView = false;
  }

  changeViewToActivityLog() {
    this.profileView = false;
    this.auditLogView = true;
    this.loginActivityView = false;
    this.changePasswordView = false;
    this.changeCommunicationsView = false;
  }

  changeViewToChangePasswordView() {
    this.profileView = false;
    this.auditLogView = false;
    this.loginActivityView = false;
    this.changePasswordView = true;
    this.changeCommunicationsView = false;
  }

  changeViewToChangeCommunicationsView() {
    this.profileView = false;
    this.auditLogView = false;
    this.loginActivityView = false;
    this.changePasswordView = false;
    this.changeCommunicationsView = true;
  }

  private setTab() {
    this.activatedRoute.fragment.subscribe(fragment => {
      if (fragment != null) {
        if (fragment.startsWith('activity')) {
          this.changeViewToLoginActivity();
        } else if (fragment.startsWith('log')) {
          this.changeViewToActivityLog();
        } else if (fragment.startsWith('password') && !this.staffView) {
          this.changeViewToChangePasswordView();
        } else if (fragment.startsWith('notifications') && !this.staffView) {
          this.changeViewToChangeCommunicationsView();
        }
      }
    });
  }
}
